import { useCallback, useEffect, useState } from "react";
import { Tooltip } from "antd";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "./sidebarCollapse.scss";

/**
 * The sidebar's icons-only ("rail") mode.
 *
 * The site-visit tables are 40 columns wide and the menu is 283px of that, so the
 * menu folds down to a 76px rail of icons and hands the difference to the page.
 * The choice is remembered because it goes with how someone works — on a laptop
 * the rail stays folded all day, on a wide screen it never does.
 *
 * Both layouts (project and admin) share this so the two sidebars behave the same.
 */
const PREF_KEY = "sidebar.iconsOnly";

export const useSidebarCollapse = () => {
  const [iconsOnly, setIconsOnly] = useState(() => {
    try {
      return localStorage.getItem(PREF_KEY) === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(PREF_KEY, String(iconsOnly));
    } catch {
      // A blocked localStorage only costs the remembered choice.
    }
  }, [iconsOnly]);

  const toggle = useCallback(() => setIconsOnly((prev) => !prev), []);

  return [iconsOnly, toggle];
};

export const SidebarCollapseToggle = ({ collapsed, onToggle }) => {
  const label = collapsed ? "Expand the menu" : "Collapse the menu to icons";
  return (
    <Tooltip title={label} placement="right">
      <button
        type="button"
        className="sidebarCollapseToggle"
        onClick={onToggle}
        aria-label={label}
        aria-pressed={collapsed}
      >
        {collapsed ? <FiChevronRight size={16} /> : <FiChevronLeft size={16} />}
      </button>
    </Tooltip>
  );
};

export default SidebarCollapseToggle;
